import { IconPropTypes } from '@/legacy/types';

const PremiumIcon = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 16}
			height={props.height || 12}
			viewBox='0 0 16 12'
		>
			<path
				fill='url(#premium-gradient)'
				fillRule='evenodd'
				d='M4.305 3.595 7.28.315A.974.974 0 0 1 8 0c.276 0 .54.115.721.316l2.974 3.279 2.837-1.724a.99.99 0 0 1 1.038.01.907.907 0 0 1 .418.914l-1.348 8.107c-.105.633-.673 1.098-1.338 1.098H2.699c-.666 0-1.234-.465-1.338-1.098L.012 2.795a.907.907 0 0 1 .418-.914.99.99 0 0 1 1.038-.01l2.837 1.724Z'
				clipRule='evenodd'
			/>
			<defs>
				<linearGradient
					id='premium-gradient'
					x1={-8.909}
					x2={27.289}
					y1={14.625}
					y2={9.898}
					gradientUnits='userSpaceOnUse'
				>
					<stop
						offset={0.283}
						stopColor='#FFB804'
					/>
					<stop
						offset={0.498}
						stopColor='#FFDD85'
					/>
					<stop
						offset={0.617}
						stopColor='#EBE6FF'
					/>
					<stop
						offset={0.705}
						stopColor='#C9BCFF'
					/>
					<stop
						offset={0.782}
						stopColor='#9B86EC'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default PremiumIcon;
